<template>
    <div class="status-tag" :class="`status-tag-${type}`">
        {{ text }}
    </div>
</template>

<script>
export default {
    name: 'StatusTag',
    props: {
        type: {
            type: String,
            required: true,
            validator: (value) => ['sended', 'orderpack', 'orderpacked', 'packing', 'packed', 'outed', 'checked', 'void', 'joined'].includes(value)
        }
    },
    computed: {
        text() {
            const statusMap = {
                sended: this.$t('statusTag.sended'),
                orderpack: this.$t('statusTag.orderpack'),
                orderpacked: this.$t('statusTag.orderpacked'),
                packing: this.$t('statusTag.packing'),
                packed: this.$t('statusTag.packed'),
                outed: this.$t('statusTag.outed'),
                checked: this.$t('statusTag.checked'),
                void: this.$t('statusTag.void'),
                joined: this.$t('statusTag.joined')
            }
            return statusMap[this.type] || ''
        }
    }
}
</script>

<style lang="scss" scoped>
.status-tag {
    display: inline-block;
    padding: 6px 16px;
    border: 2px solid;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    min-width: 100px;
}

.status-tag-sended {
    color: #409EFF;
    border-color: #409EFF;
    background-color: #ECF5FF;
}

.status-tag-orderpack {
    color: #E6A23C;
    border-color: #E6A23C;
    background-color: #FDF6EC;
}

.status-tag-orderpacked {
    color: #67C23A;
    border-color: #67C23A;
    background-color: #F0F9FF;
}

.status-tag-packing {
    color: #E6A23C;
    border-color: #E6A23C;
    background-color: #FDF6EC;
}

.status-tag-packed {
    color: #67C23A;
    border-color: #67C23A;
    background-color: #F0F9FF;
}

.status-tag-outed {
    color: #67C23A;
    border-color: #67C23A;
    background-color: #F0F9FF;
}

.status-tag-checked {
    color: #409EFF;
    border-color: #409EFF;
    background-color: #ECF5FF;
}

.status-tag-void {
    color: #F56C6C;
    border-color: #F56C6C;
    background-color: #FEF0F0;
}

.status-tag-joined {
    color: #67C23A;
    border-color: #67C23A;
    background-color: #F0F9FF;
}
</style>
